import { makeStyles } from '@material-ui/core/styles';

// Matches the price details box's rows and rules (price-details.styles.js).
export default makeStyles((theme) => ({
  divider: {
    margin: 0,
    '&::before, &::after': {
      backgroundColor: theme.colorPalette.green_75,
      opacity: 0.5
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  label: {
    flex: 1,
    lineHeight: '20px',
    color: theme.colorPalette.beige_60
  },
  value: {
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    color: theme.colorPalette.beige_25
  }
}));
